import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { setDomainInfo } from "reduxStore/actions";
import { mapDomainInfo } from "utils/checkDomain";
import { MainRoutes } from "routes";
import ErrorBoundary from "components/errorBoundary";

const App = () => {
  useEffect(() => {
    setDomainInfo(mapDomainInfo());
  }, [])
  
  return (
    <div className="App h-100">
      <Helmet titleTemplate="Bzquick" defaultTitle={mapDomainInfo().title}>
        <meta name='description' content={mapDomainInfo().description} />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={mapDomainInfo().favicon}
        />
      </Helmet>
      <div className="main-container-wrapper h-100">
      <ErrorBoundary>
        <MainRoutes />
        </ErrorBoundary>

      </div>
    </div>
  );
};

export default App;
